import { Component, Input, OnInit } from '@angular/core';
import { Setting } from '../../interfaces/setting';
import { Subscription } from 'rxjs';
import { SettingService } from '../../services/setting.service';
import { Notyf } from 'notyf';

@Component({
  selector: 'app-setting-form',
  templateUrl: './setting-form.component.html',
  styleUrls: ['./setting-form.component.scss']
})
export class SettingFormComponent implements OnInit {

  @Input() setting: Setting
  isRequresting = false as boolean;
  visible= true as boolean;

  notyf = new Notyf({
    duration: 1000,
    position: {
      x: 'right',
      y: 'top',
    }
  });


  constructor(
    private settingService: SettingService
  ) { }

  ngOnInit() {
  }

  update() {
    this.settingService.update(this.setting).subscribe({
      next: response => {
        if (201 === response.status) {
          // this.notyf.success(response.message);
        } else {
          // this.notyf.error(response.message);
        }
        this.isRequresting = false;
      },
      error: error => {
        // this.notyf.error('Something went wrong');
        this.isRequresting = false;
      }
    });
  }

  save() {
    this.settingService.save(this.setting).subscribe({
      next: response => {
        if (201 === response.status) {
          this.setting = response.data;
          // this.notyf.success(response.message);
        } else {
          // this.notyf.error(response.message);
        }
        this.isRequresting = false;
      },
      error: error => {
        // this.notyf.error('Something went wrong');
        this.isRequresting = false;
      }
    });
  }

  onSubmit() {
    this.isRequresting = true;
    if (this.setting._id) {
      this.update();
    } else {
      this.save();
    }
  }

  remove(){
    this.visible= false;
  }

}



// WEBPACK FOOTER //
// ./src/app/components/setting-form/setting-form.component.ts